<template>
  <div id="sispessoal-modulo-wrapper">
    <div v-if="isModuloLoading" id="sispessoal-modulo-progress">
      <BaseProgressBar v-bind="progressBar" />
    </div>
    <component
      v-else
      v-bind:is="moduloComponentOptions"
      style="height: 100%"
    ></component>
  </div>
</template>

<script>
import { ModuloService } from "../services";

export default {
  name: "TheModuloContainer",
  inheritAttrs: false,
  props: {
    moduloSystemName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      moduloComponentOptions: null,
      progressBar: {
        useContainer: false
      }
    };
  },
  computed: {
    isModuloLoading() {
      return this.$store.state.loadingModulo;
    }
  },
  watch: {
    moduloSystemName: function (newModuloSystemName, oldModuloSystemName) {
      this.deactivateModulo(oldModuloSystemName);
      this.renderModulo(newModuloSystemName);
    }
  },
  mounted() {
    this.renderModulo(this.moduloSystemName);
  },
  beforeDestroy() {
    this.deactivateModulo(this.moduloSystemName);
  },
  methods: {
    renderModulo(moduloSystemName) {
      ModuloService.activateModulo(moduloSystemName);

      const downloadedModulo = this.$store.getters.getDownloadedModulo(
        "systemName",
        moduloSystemName
      );

      if (!downloadedModulo) {
        return this.$notification.pushError("Módulo não encontrado.");
      }

      this.$store.commit("updateBreadcrumbs", {
        moduloSystemName,
        route: this.$route
      });

      this.moduloComponentOptions = {
        ...downloadedModulo.component,
        parent: this
      };
    },
    deactivateModulo(moduloSystemName) {
      ModuloService.deactivateModulo(moduloSystemName);
    }
  }
};
</script>

<style>
#sispessoal-modulo-wrapper {
  min-height: calc(100vh - 64px - 211.25px);
  max-height: max-content;
}

#sispessoal-modulo-progress .progress {
  margin: 0;
  border-radius: 0;
}
</style>
